import React = require('react');

interface IMTAButtons {
  button1: any;
  history?: any;
  hasGoBack?: boolean;
  button2?: any;
  cancellation?: boolean;
}

export const MTAButtons = ({
                             button1,
                             button2 = null,
                             hasGoBack = false,
                             history = null,
                             cancellation = false,
                           }: IMTAButtons) => {

  const func = history?.goBack;

  if (cancellation && button1 && button2) {
    return (
      <div className={'mta-cancel-buttons-container'}>
        <div className={'button1-wrapper'}>{button1}</div>
        <div className={'button2-wrapper'}>{button2}</div>
      </div>
    )
  }

  if (button1 && button2) {
    return (
      <div className={'mta-buttons-container'}>
        <div className={'button1-wrapper'}>{button1}</div>
        <div className={'button2-wrapper'}>{button2}</div>
      </div>
    )
  }

  if (button1 && hasGoBack && history) {
    return (
      <div className={'mta-buttons-container'}>
        <div className={'button1-wrapper'}>{button1}</div>
        <div className={'button2-wrapper'}>
          <div className={'go-back-button'} onClick={func}>
            GO BACK
          </div>
        </div>
      </div>
    )
  }

  if (button1 && !button2 && !hasGoBack) {
    return (
      <div className={'mta-buttons-container'}>
        <div className={'button1-wrapper'}>{button1}</div>
      </div>
    )
  }
}
